export default __webpack_public_path__ + "assets/src/objects/Flat.gltf";